import graphqlClient from '@/graphql/graphql-client';
import { useMutation } from '@tanstack/react-query';

import type { InsertUserProfilesMutation, InsertUserProfilesMutationVariables } from '@/graphql/generated/graphql';
import { InsertUserProfilesDocument } from '@/graphql/generated/graphql';
export type UserProfileInsertInput = {
  OrganizationIds?: string[]
  BlocksUserId?: string
  JobTitle?: string
  Department?: string
  OnboardingCompleted?: boolean
  OnboardingCompletedAt?: string
  OnboardingStepsCompleted?: string[]
}

export type InsertUserProfileResponse = {
  data: {
    insertUserProfiles: {
      itemId: string
      totalImpactedData: number
      acknowledged: boolean
      message?: string | null
    }
  }
}

export const useInsertUserProfile = () => {
  const mutation = useMutation({
    mutationKey: ['insert-user-profile'],
    mutationFn: (variables: UserProfileInsertInput) => {
      return graphqlClient.request<InsertUserProfilesMutation>(InsertUserProfilesDocument,
        variables
      )
    }
  })

  return {
    ...mutation,
    insertUserProfile: mutation.mutate,
    insertUserProfileAsync: mutation.mutateAsync,
  }
}

export const INSERT_USER_PROFILE_MUTATION = InsertUserProfilesDocument;
